import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { POSModel } from '../../../shared/models/pos.model';
import { POSService } from '../../../shared/services/pos.service';
import { Page } from '../../../shared/models/page.model';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../shared/services/auth.service';
import { ModalDirective } from 'ngx-bootstrap';
import { MessageService } from '../../../@pages/components/message/message.service';
import { Utils } from '../../../shared/services/utils.service';
import { TokenModel } from '../../../shared/models/token.model';
import { TokenService } from '../../../shared/services/token.service';
import { ErrorHandlingService } from '../../../shared/services/error-handling.service';

@Component({
  selector: 'app-token-list',
  templateUrl: './token-list.component.html',
  styleUrls: ['./token-list.component.scss']
})
export class TokenListComponent implements OnInit {


  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;

  freeSearch: string;
  tokens: TokenModel[];
  ColumnMode = ColumnMode;
  page: Page = new Page();
  currentPage = 1;
  columns = [];
  rows = [];
  
  searchParams = { per_page: environment.per_page, page: this.currentPage };

  constructor(
    private router: Router,
    private tokenService: TokenService,
    private authService: AuthService,
    private messageService : MessageService,
    private utils : Utils,
    private route : ActivatedRoute,
    private errorHandler : ErrorHandlingService
  ) {

    }

  ngOnInit() {
    this.loadFilters();
    this.loadTokens();
    this.columns = [
      { name: 'Name', flexGrow: 1, sortable: true, cellClass: 'Token_name', headerClass: 'Token_name' },
      { name: 'Email', flexGrow: 3, sortable: true, cellClass: 'Token_email', headerClass: 'Token_email' }
    ];
    this.updateMenuItems();
  }

  onSort(event) {
    this.searchParams['order_by'] = event['column']['prop'];
    this.searchParams['order_asc_desc'] = event['newValue'];
    this.loadTokens();
  }

  loading = {
    isFirstLoad:false,
    isLoading:false
  };

  isLoading:boolean = false;
  loadTokens() {
    let _this = this;
    _this.tokens = [];
    if(!_this.loading.isFirstLoad){
      _this.loading.isFirstLoad = true;
      _this.loading.isLoading = true; 
    }
    _this.isLoading = true;
    this.tokenService.getAll(this.searchParams).subscribe(res => {
      res['meta']['per_page'] = +res['meta']['per_page']; 
      _this.page = res['meta'];
      _this.tokens = res['data'];
      _this.rows = [];
      for (let Token of _this.tokens) {
        _this.rows.push(
          {
            id: Token.id,
            uuid: Token.uuid,
            guest: Token.guest,
            type:Token.type,
            expiry_date:Token.expiry_date,
            remaining_balance: parseFloat(Token.remaining_balance),
            is_blocked:Token.is_blocked
          }
        );
      }
      if(res['data'].length == 0){
        //this.messageService.error("No Tokens Found.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
      }
      console.log(_this.page);
      _this.loading.isLoading = false;
      _this.isLoading = false;
    },
    err => {
      _this.loading.isLoading = false;
      _this.isLoading = false;
      console.log(err);
    });
  }

  hasPermission(permission){
    return this.authService.hasPermission(permission);
  }

  setPage(pageInfo) {
    this.currentPage = pageInfo.offset + 1;
    this.searchParams.page = this.currentPage;
    this.loadTokens();
    this.setFilter("pageToken",""+this.currentPage);
  }

  ngAfterViewInit() {
    this.table.bodyComponent.updatePage = function (direction: string): void {
      let offset = this.indexes.first / this.pageSize;

      if (direction === 'up') {
        offset = Math.ceil(offset);
      } else if (direction === 'down') {
        offset = Math.floor(offset);
      }

      if (direction !== undefined && !isNaN(offset)) {
        this.page.emit({ offset });
      }
    }
  }

  onFocus(event) {
    if (event['type'] == 'click') {
      let id = event['row']['id'];
      this.router.navigate(['/token/' + id]);
    }
  }

  clearFilters() {
    this.freeSearch = "";
    this.updateFilters();
  }

  historyChange:EventEmitter<boolean> = new EventEmitter<boolean>();
  filteredParams:any = {};
  filterUpdateTimeout:any;
  setFilter(name, value) {
    let _this = this;
    _this.filteredParams = {..._this.filteredParams,[name]:value};
    this.utils.pushFiltersToRouter(value,name,_this.filteredParams).subscribe(res => {
      window.history.pushState(null,"",("token"+res));
      _this.historyChange.emit(true);
    });
  }

  getFilter(name): any {
    let value = this.route.snapshot.queryParams[name];
    if(isNaN(+value)){
      return value;
    }
    return +value;
  }

  saveFilters() {
    let _this = this;
    setTimeout(() => {
      _this.setFilter("pageToken", _this.currentPage);
      _this.setFilter("searchToken", _this.freeSearch);
    }, 250);
  }

  loadFilters() {
    this.freeSearch = this.getFilter("searchToken");
    this.currentPage = (this.getFilter("pageToken") ? this.getFilter("pageToken") : 1);
    this.updateFilters();
  }

  filterLoadTimeout:any
  updateFilters(skip?) {
    let _this = this;
		_this.searchParams = { per_page: environment.per_page, page: 1 };
		if (!skip) {
		_this.searchParams.page = _this.currentPage;
		}
		else {
		_this.currentPage = 1;
		_this.setFilter("pageToken", 1);
		}
    if (this.freeSearch) {
      this.searchParams['q'] = this.freeSearch;
    }
    if (this.filterLoadTimeout) {
			clearTimeout(this.filterLoadTimeout);
		}
		this.filterLoadTimeout = setTimeout(() => {
			this.loadTokens();
		}, 350);
    this.saveFilters();
  }


  //List Dot Menu Bulk Selection

  @ViewChild('mdSlideUp', { static: true }) mdSlideUp: ModalDirective;
  openBulk() {
    this.mdSlideUp.show()
  }

  mainToggle: boolean = false;
  activeActionTitle: string;
  menuItems: any[] = [
    { action: 'export-selected', message: 'Export Selected', class: '', icon: 'fal fa-file-export', permissions: ['view_token'] },
    { action: 'export-all', message: 'Export All', class: '', icon: 'fal fa-file-export', permissions: ['view_token'] },
  ];

  handleButtonPress(event) {
    switch (event) {
      case "export-selected":
        this.activeActionTitle = "Export Selected";
        this.openBulk();
        break;
      case "export-all":
        this.activeActionTitle = "Export All";
        this.openBulk();
        break;
      default:
        console.log(event);
        break;
    }
  }

  getRowClass = (row) => {
    return {
      'is-locked': row.is_blocked
    };
 }
  
  activeRows:Map<number,any> = new Map<number,any>();
  toggle(row) {
    if(row.is_blocked){
      row['bulk_checked'] = false;
      return;
    }
    row['bulk_checked'] = !row['bulk_checked'];
    let _this = this;
    if(row['bulk_checked']){
      _this.activeRows.set(row['id'],row);
    }
    else{
      _this.activeRows.delete(row['id']);
    }
    this.updateMenuItems();
  }

  isToggled = (row) => {
    return this.activeRows.has(row['id']);
  }

  onActivate(event){
    if(event['type'] == 'click'){
      let row = event['row'];
      console.log(row);
      this.router.navigate(['/token/'+row.id]);
    }
  }

  @ViewChild('unblockToken', { static: true }) unblockToken: ModalDirective;
  token:any;
  unblock() {
    let _this = this;
    this.loading.isLoading = true;
    this.tokenService.unblock(this.token.id).subscribe(res => {
      _this.token = null;
      _this.loadTokens();
      _this.unblockToken.hide();
      this.messageService.success("Token has been Unblocked.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
      _this.loading.isLoading = false;
    },
      err => {
        _this.loading.isLoading = false;
        this.messageService.error(this.errorHandler.getErrors(err)[0], { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        console.log(err);
      });
  }
  
  unlockToken(token){
    this.token = token;
    this.unblockToken.show();
  }

  updateMenuItems(){
    for(let item of this.menuItems){
      if(this.activeRows.size == 0){
        if(item.action.includes('export-selected')){
          item.Disabled = true;
        }
      }
      else{
        if(item.action.includes('export-selected')){
          item.Disabled = false;
        }
      }
    }
    return this.menuItems;
  }

  toggleAll() {
    let _this = this;
    this.mainToggle = !this.mainToggle;
    for (let item of _this.rows) {
      if(item.is_blocked){
        continue;
      }
      if(this.mainToggle == true){
        _this.activeRows.set(item.id,item);
      }
      else{
        _this.activeRows.delete(item.id);
      }
    }
    this.updateMenuItems();
  }

  submitToggle() {
    this.utils.submitToggle(this.activeActionTitle, this.messageService, this.searchParams, Array.from(this.activeRows.values()), 'Token');
    this.activeRows = new Map<number,any>();
  }

}